import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/$locale/job-tracker')({
  ssr: false, // CSR only - no SEO needed
})
